<template>
  <div class="dialogComponent">
    <el-dialog
      :before-close="handleClose"
      :visible.sync="visible"
      :width="width"
      :append-to-body="true"
      :show-close="showClose"
      :close-on-press-escape="pressClick"
      :destroy-on-close="true"
      :close-on-click-modal="closeClick"
      center>
      <div slot="title">
        <dialog-header :title="dialogTitle"></dialog-header>
      </div>
      <slot name="content"></slot>
      <slot name="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>
import DialogHeader from "@/components/device_details/comp/DialogHeader";

export default {
  name: "DialogComponent",
  components: {DialogHeader},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '50%',
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    pressClick: {
      type: Boolean,
      default: true,
    },
    closeClick: {
      type: Boolean,
      default: true,
    },
    widthList: {
      type: Array,
      default: () => [],
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (this.widthList.length > 0) {
          this.widthList.forEach(item => {
            if (window.innerWidth < item.innerWidth) {
              this.width = item.width
            }
          })
        }
      })();
    };
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val
        if (val) {
          this.$emit('dialogShow', this.visible)
        }
      }
    },
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$emit('dialogClose', this.visible)
    }
  },
  destroyed() {
    window.onresize = null
  }
}
</script>

<style>

/*@media (max-width: 1441px) {*/

/*  .dialogComponent .el-dialog {*/
/*    width: 80% !important;*/
/*  }*/
/*}*/
@media (max-width: 767px) {
  .el-dialog {
    width: 80% !important;
    max-width: 1200px;
    /*margin-top: 0 !important;*/
    /*height: 100%;*/
  }

  .dialogComponent .el-dialog__wrapper {
    overflow: inherit;
  }
}
</style>
